import Yup from '~/utils/validations/yup';

export const schemaValidation = Yup.object({
  apps: Yup.array(Yup.mixed()),
  myApps: Yup.array(Yup.mixed()),
});
